/* ============================================================
   SWIPE TO PICK — /pages/swipe  (v114, 29 Sep 2026)
   Markup and data: sections/main-swipe.liquid

   One frame at a time. Right = "I'd wear it", left = "not for me".
   Works by finger (pointer events), by the two round buttons, and by the
   arrow keys (Z to undo). A tap on the photo, as opposed to a drag, shows
   the next photo of the same frame.

   Progress is kept in sessionStorage so a shopper who opens a product page
   from the picks list and comes back finds their picks still there. Every
   read and write is wrapped: private windows and some in-app browsers throw,
   and the page must work the same without it.

   ADD TO BAG goes through the theme's own paths so the bag behaves exactly as
   everywhere else:
     - one frame: a real <form action="/cart/add">, which cart-drawer.js
       already intercepts (adds, then opens the drawer);
     - top two: one POST to /cart/add.js with both, then a click on the
       header's [data-cart-drawer-open], which re-renders the drawer — and
       that render is what swaps the cheaper frame onto its 2nd-frame price.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-swp]');
  var dataEl = document.getElementById('swp-data');
  if (!root || !dataEl) return;

  var DATA = { women: [], men: [] };
  try { DATA = JSON.parse(dataEl.textContent) || DATA; } catch (e) {}

  var screens = {
    start: root.querySelector('[data-swp-screen="start"]'),
    play: root.querySelector('[data-swp-screen="play"]'),
    end: root.querySelector('[data-swp-screen="end"]')
  };
  var stack = root.querySelector('[data-swp-stack]');
  var countEl = root.querySelector('[data-swp-count]');
  var barEl = root.querySelector('[data-swp-bar]');
  var undoBtn = root.querySelector('[data-swp-undo]');

  var KEY = 'tbt-swipe-v1';
  var state = null;   /* { g: 'women'|'men', i: index, likes: [v...], hist: ['y'|'n'...] } */
  var busy = false;

  /* ---------- storage ---------- */
  function save() {
    try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function clearSaved() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }

  function deck() { return (state && DATA[state.g]) || []; }
  function byVariant(v) {
    var d = deck();
    for (var i = 0; i < d.length; i++) if (d[i].v === v) return d[i];
    return null;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = (k !== name); });
    /* Bring the top of the section into view on every screen change — on a
       phone the start button sits below the fold after the header. */
    var top = root.getBoundingClientRect().top + window.pageYOffset - 70;
    if (Math.abs(window.pageYOffset - top) > 40) window.scrollTo(0, Math.max(0, top));
  }

  /* ---------- cards ---------- */
  function cardHTML(f, pos) {
    var imgs = f.img && f.img.length ? f.img : [''];
    var dots = imgs.length > 1
      ? '<span class="swp-dots">' + imgs.map(function (_, n) { return '<i' + (n === 0 ? ' class="is-on"' : '') + '></i>'; }).join('') + '</span>'
      : '';
    var tags = '';
    if (f.pol) tags += '<span class="swp-tag">Polarised</span>';
    return '' +
      '<div class="swp-card' + (pos ? ' is-next' : '') + '" data-swp-card data-v="' + f.v + '" data-img="0">' +
        '<div class="swp-photo">' +
          '<img src="' + esc(imgs[0]) + '" alt="' + esc(f.t) + '" draggable="false"' + (pos ? ' loading="lazy"' : '') + '>' +
          dots +
          '<span class="swp-stamp swp-stamp--yes" aria-hidden="true">Would wear</span>' +
          '<span class="swp-stamp swp-stamp--no" aria-hidden="true">Not for me</span>' +
        '</div>' +
        '<div class="swp-info">' +
          '<div class="swp-info-row"><h3>' + esc(f.t) + '</h3><strong>' + esc(f.price) + '</strong></div>' +
          '<p>' + esc(f.s) + '</p>' +
          (tags ? '<div class="swp-tags">' + tags + '</div>' : '') +
        '</div>' +
      '</div>';
  }

  function paint() {
    var d = deck();
    if (state.i >= d.length) { finish(); return; }
    var html = '';
    /* Next card first so the current one sits on top in document order. */
    if (d[state.i + 1]) html += cardHTML(d[state.i + 1], 1);
    html += cardHTML(d[state.i], 0);
    stack.innerHTML = html;
    countEl.textContent = (state.i + 1) + ' of ' + d.length;
    barEl.style.width = Math.round((state.i / d.length) * 100) + '%';
    undoBtn.disabled = state.hist.length === 0;
    bindTop();
    /* Warm the photo after next, so the card behind never shows blank. */
    if (d[state.i + 2] && d[state.i + 2].img && d[state.i + 2].img[0]) {
      var pre = new Image(); pre.src = d[state.i + 2].img[0];
    }
  }

  function topCard() {
    var cards = stack.querySelectorAll('[data-swp-card]');
    return cards.length ? cards[cards.length - 1] : null;
  }

  /* ---------- decide ---------- */
  function decide(yes) {
    if (busy) return;
    var card = topCard();
    if (!card) return;
    busy = true;
    var dir = yes ? 1 : -1;
    card.style.transition = 'transform .32s ease-out, opacity .32s ease-out';
    card.style.transform = 'translate(' + (dir * 140) + '%, -4%) rotate(' + (dir * 22) + 'deg)';
    card.style.opacity = '0';
    card.classList.add(yes ? 'is-yes' : 'is-no');
    var next = stack.querySelector('.swp-card.is-next');
    if (next) next.classList.remove('is-next');

    var f = deck()[state.i];
    if (yes && f && state.likes.indexOf(f.v) === -1) state.likes.push(f.v);
    state.hist.push(yes ? 'y' : 'n');
    state.i += 1;
    save();

    setTimeout(function () { busy = false; paint(); }, 300);
  }

  function undo() {
    if (busy || !state.hist.length) return;
    var last = state.hist.pop();
    state.i = Math.max(0, state.i - 1);
    if (last === 'y') {
      var f = deck()[state.i];
      if (f) {
        var at = state.likes.indexOf(f.v);
        if (at > -1) state.likes.splice(at, 1);
      }
    }
    save();
    show('play');
    paint();
  }

  /* ---------- drag ---------- */
  function bindTop() {
    var card = topCard();
    if (!card) return;
    var photo = card.querySelector('.swp-photo');
    var yesS = card.querySelector('.swp-stamp--yes');
    var noS = card.querySelector('.swp-stamp--no');
    var sx = 0, sy = 0, dx = 0, dy = 0, t0 = 0, down = false, dragging = false, onPhoto = false;

    function onDown(e) {
      if (busy || (e.button !== undefined && e.button !== 0)) return;
      down = true; dragging = false;
      onPhoto = !!(e.target && e.target.closest && e.target.closest('.swp-photo'));
      sx = e.clientX; sy = e.clientY; dx = dy = 0; t0 = Date.now();
      card.style.transition = 'none';
      if (card.setPointerCapture && e.pointerId !== undefined) {
        try { card.setPointerCapture(e.pointerId); } catch (err) {}
      }
    }
    function onMove(e) {
      if (!down) return;
      dx = e.clientX - sx; dy = e.clientY - sy;
      if (!dragging && Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      dragging = true;
      card.style.transform = 'translate(' + dx + 'px,' + (dy * 0.25) + 'px) rotate(' + (dx / 18) + 'deg)';
      var p = Math.min(1, Math.abs(dx) / 110);
      yesS.style.opacity = dx > 0 ? p : 0;
      noS.style.opacity = dx < 0 ? p : 0;
    }
    function onUp() {
      if (!down) return;
      down = false;
      var dt = Math.max(1, Date.now() - t0);
      var fast = Math.abs(dx) / dt > 0.6 && Math.abs(dx) > 40;
      if (dragging && (Math.abs(dx) > 110 || fast)) {
        decide(dx > 0);
        return;
      }
      card.style.transition = 'transform .25s ease';
      card.style.transform = '';
      yesS.style.opacity = 0; noS.style.opacity = 0;
      if (!dragging && onPhoto) nextPhoto(card);
    }

    card.addEventListener('pointerdown', onDown);
    card.addEventListener('pointermove', onMove);
    card.addEventListener('pointerup', onUp);
    card.addEventListener('pointercancel', onUp);
    /* Photo taps only (onPhoto) — a tap on the name or price does nothing. */
    photo.style.cursor = 'pointer';
  }

  function nextPhoto(card) {
    var f = byVariant(parseInt(card.getAttribute('data-v'), 10));
    if (!f || !f.img || f.img.length < 2) return;
    var n = (parseInt(card.getAttribute('data-img'), 10) + 1) % f.img.length;
    card.setAttribute('data-img', n);
    card.querySelector('.swp-photo img').src = f.img[n];
    [].forEach.call(card.querySelectorAll('.swp-dots i'), function (d, k) { d.classList.toggle('is-on', k === n); });
  }

  /* ---------- end ---------- */
  function finish() {
    var picks = state.likes.map(byVariant).filter(Boolean);
    var title = root.querySelector('[data-swp-end-title]');
    var lede = root.querySelector('[data-swp-end-lede]');
    var list = root.querySelector('[data-swp-picks]');
    var offer = root.querySelector('[data-swp-offer]');
    var two = root.querySelector('[data-swp-add-two]');
    var all = root.querySelector('[data-swp-all]');

    all.href = state.g === 'men' ? '/collections/men' : '/collections/women';
    all.textContent = state.g === 'men' ? "See all men's frames" : "See all women's frames";

    if (!picks.length) {
      title.textContent = 'Nothing caught your eye?';
      lede.textContent = 'Fair enough. Try the face check — it tells you which shapes suit you — or browse them all.';
      list.className = 'swp-picks';
      list.innerHTML = '<a class="button full" href="/pages/face-check">Check with your camera</a>';
      offer.hidden = true; two.hidden = true;
    } else {
      title.textContent = picks.length === 1 ? 'You picked one.' : 'You picked ' + picks.length + '.';
      lede.textContent = picks.length === 1
        ? 'Good taste. Add it to your bag, or open it for every photo and the details.'
        : 'In the order you liked them. Add one, or add your top two.';
      offer.hidden = picks.length < 2;
      two.hidden = picks.length < 2;
      /* Picks as a photo grid, like the collection page (Dev, 29 Sep): big
         square photo, name, shape, price, and Add to bag on every card. */
      list.className = 'swp-grid';
      list.innerHTML = picks.map(function (f) {
        return '' +
          '<div class="swp-gcard">' +
            '<a class="swp-gimg" href="' + esc(f.u) + '">' +
              '<img src="' + esc(f.img[0] || '') + '" alt="' + esc(f.t) + '" loading="lazy">' +
            '</a>' +
            '<div class="swp-ginfo">' +
              '<a href="' + esc(f.u) + '"><h3>' + esc(f.t) + '</h3></a>' +
              '<p>' + esc(f.s) + '</p>' +
              '<strong>' + esc(f.price) + '</strong>' +
            '</div>' +
            '<form action="/cart/add" method="post" class="swp-gadd">' +
              '<input type="hidden" name="id" value="' + f.v + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button type="submit" class="button full">Add to bag</button>' +
            '</form>' +
          '</div>';
      }).join('');
    }
    barEl.style.width = '100%';
    show('end');
  }

  function addTopTwo(btn) {
    var picks = state.likes.map(byVariant).filter(Boolean).slice(0, 2);
    if (picks.length < 2) return;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: picks.map(function (f) { return { id: f.v, quantity: 1 }; }) })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        var opener = document.querySelector('[data-cart-drawer-open]');
        if (opener) opener.click(); else window.location.href = '/cart';
      })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { btn.disabled = false; btn.textContent = label; });
  }

  /* ---------- start ---------- */
  function begin(g) {
    if (!DATA[g] || !DATA[g].length) return;
    state = { g: g, i: 0, likes: [], hist: [] };
    save();
    show('play');
    paint();
  }

  function restart() {
    clearSaved();
    state = null;
    stack.innerHTML = '';
    show('start');
  }

  root.addEventListener('click', function (e) {
    var go = e.target.closest('[data-swp-go]');
    if (go) { begin(go.getAttribute('data-swp-go')); return; }
    if (e.target.closest('[data-swp-yes]')) { decide(true); return; }
    if (e.target.closest('[data-swp-no]')) { decide(false); return; }
    if (e.target.closest('[data-swp-undo]')) { undo(); return; }
    if (e.target.closest('[data-swp-restart]')) { restart(); return; }
    var two = e.target.closest('[data-swp-add-two]');
    if (two) { addTopTwo(two); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (screens.play.hidden) return;
    if (e.target && /input|textarea|select/i.test(e.target.tagName)) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); decide(true); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); decide(false); }
    else if (e.key === 'z' || e.key === 'Z') { undo(); }
  });

  /* ---------- resume, or ?for=women / ?for=men ---------- */
  var saved = load();
  var want = null;
  try { want = new URLSearchParams(window.location.search).get('for'); } catch (e) {}

  if (saved && DATA[saved.g] && (!want || want === saved.g)) {
    state = saved;
    state.likes = (state.likes || []).filter(function (v) { return !!byVariant(v); });
    state.hist = state.hist || [];
    show('play');
    paint();
  } else if (want && DATA[want] && DATA[want].length) {
    begin(want);
  }
})();
